import { createFileRoute, notFound } from "@tanstack/react-router";

// Catch-all for unmatched paths. The router sets HTTP 404 automatically on
// notFound() throws during SSR, and the root route's notFoundComponent
// (see __root.tsx) renders the 404 UI.
export const Route = createFileRoute("/$")({
	loader: () => {
		throw notFound();
	},
});
